<template lang="pug">
  .BaseTag.base-tag(
    :style="{ background: background }"
    :class="{'is--round': round, 'is--white-text': whiteTextColor, 'is--strong-text': strongText, 'is--icon': icon,}"
  )
    .base-tag__icon-wrapper
      slot(name="icon")
    p.base-tag__text
      slot
</template>

<script>

export default {
  name: 'BaseTag',
  props: {
    text: String,
    round: Boolean,
    icon: Boolean,
    strongText: Boolean,
    whiteTextColor: Boolean,
    background: {
      type: String,
      default: '#F2F4F5',
    },
  },
};
</script>

<style lang="sass">
@import '~Styles/_variables'
.base-tag
  padding: 4px 8px
  color: $primary
  display: flex
  flex-direction: row
  align-items: center
  $root: &
  &.is--round
    border-radius: 24px
  &.is--strong-text
    #{$root}__text
      +font(500)
  &.is--white-text
    color: $white
  &__text
    font-size: 12px
    +font(400)
    line-height: 16.8px
    margin-bottom: 0 !important
  &.is--icon
    padding-left: 6px
    #{$root}__icon-wrapper
      margin-right: 4px
      display: flex
      align-items: center
      justify-content: center
  &__icon-wrapper
    width: 16px
    height: 16px
    display: none
    svg
      width: 16px
      height: 16px
    div
      display: flex
</style>
